import { PaymentAmount } from '../../../types';

export interface ICashAppWindowObject {
    pay({ clientId }: { clientId: string }): Promise<ICashAppSDK>;
}

/**
 * @link https://developers.cash.app/cash-app-pay-partner-api/guides/pay-kit-sdk/pay-kit-web-overview/technical-reference
 */
export interface ICashAppSDK {
    render(target: string | HTMLElement, options?: unknown): Promise<{ begin?: () => void }>;
    addEventListener(eventType: CashAppPayEvents, callback: Function): void;
    removeEventListener(eventType: CashAppPayEvents, callback: Function): void;
    customerRequest(customerRequest: unknown): Promise<void>;
    restart(): Promise<void>;
}

export enum CashAppPayEvents {
    CustomerDismissed = 'CUSTOMER_DISMISSED',
    CustomerRequestApproved = 'CUSTOMER_REQUEST_APPROVED',
    CustomerRequestDeclined = 'CUSTOMER_REQUEST_DECLINED',
    CustomerRequestFailed = 'CUSTOMER_REQUEST_FAILED'
}

export interface ICashAppService {
    begin(): void;
    initialize(): Promise<void>;
    setStorePaymentMethod(store: boolean): void;
    renderButton(target: HTMLElement): Promise<void>;
    restart(): Promise<void>;
    createCustomerRequest(amount: PaymentAmount): Promise<void>;
    subscribeToEvent(eventType: CashAppPayEvents, callback: Function): Function;
}

export type CashAppServiceConfig = {
    useCashAppButtonUi: boolean;
    storePaymentMethod: boolean;
    environment: string;
    clientId: string;
    scopeId: string;
    referenceId?: string;
    redirectURL?: string;
    button?: {
        shape?: 'semiround' | 'round';
        size?: 'medium' | 'small';
        theme?: 'dark' | 'light';
        width?: 'static' | 'full';
    };
};
